(() => {
  if (!window.customElements || customElements.get('sac-merch-scroll')) return;

  class SacMerchScroll extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-merch-track]');
      this.previous = this.querySelector('[data-merch-previous]');
      this.next = this.querySelector('[data-merch-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => this.onKeydown(event), options);
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.scheduleUpdate(), options);
      }
      this.dataset.ready = 'true';
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      delete this.dataset.ready;
    }

    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const position = Math.min(maximum, Math.max(0, this.track.scrollLeft * direction));
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
    }

    move(direction) {
      const card = this.track.querySelector('.sac-merch__card');
      if (!card) return;
      const style = getComputedStyle(this.track);
      const gap = Number.parseFloat(style.columnGap) || 0;
      const stride = card.getBoundingClientRect().width + gap;
      if (!(stride > 0)) return;
      const visible = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / stride));
      const sign = style.direction === 'rtl' ? -1 : 1;
      this.track.scrollBy({ left: direction * sign * stride * visible, behavior: this.behavior() });
    }

    behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    onKeydown(event) {
      if (event.target !== this.track) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({ left: event.key === 'Home' ? 0 : maximum * (rtl ? -1 : 1), behavior: this.behavior() });
      }
    }
  }

  customElements.define('sac-merch-scroll', SacMerchScroll);
})();
